import { endpoints } from "../endpoints";
import axiosInstance from "../axiosInstance";
import { dateObjects } from "./editor.api";
import ApiRequest from "../axiosInstance/request";

export const filterDate = async (data) => {
  try {
    const res = await axiosInstance.get(
      `${endpoints.copywriters.writerList}?published_at_from=${data.startDate}&published_at_to=${data.endDate}`
    );
    return res.data;
  } catch (error) {
    console.warn(error);
  }
};
export const searchCopywriters = async (data) => {
  try {
    const res = await axiosInstance.get(
      `${endpoints.copywriters.writerList}?search=${data}`
    );
    return res.data;
  } catch (error) {
    console.warn(error);
  }
};
export const statusCopywriters = async (data) => {
  try {
    const res = await axiosInstance.get(
      `${endpoints.copywriters.writerList}?status=${data}`
    );
    return res.data;
  } catch (error) {
    console.warn(error);
  }
};
// export const totalCopywriters = async () => {
//   try {
//     const res = await axiosInstance.get(`${endpoints.copywriters.writerList}`);
//     return res.data;
//   } catch (error) {
//     console.warn(error);
//   }
// };

export const totalCopywriters = (data, page) => {
  console.warn("🚀 ~ file: editor.api.js:62 ~ totaleditorList ~ cpage:", page);

  return new Promise((resolve, reject) => {
    ApiRequest.get(
      `${endpoints.copywriters.writerList}?status=${page?.status}&search=${page?.search}&published_at_from=${page?.startDate}&published_at_to=${page?.endDate} &page=${data}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const CopyWUserDeatilsutation = async (data) => {
  return new Promise((resolve, reject) => {
    ApiRequest.get(`${endpoints.auth.userdeatils}?user_id=${data}`)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// export const CopyWVIDEOMutation = async (data) => {
//   return new Promise((resolve, reject) => {
//     ApiRequest.get(
//       `${endpoints.videos.videos}?copyright_id=${data?.copyW_id}&page=${data?.page}`
//     )
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };

export const CopyWVIDEOMutation = async (datas) => {
  function buildQueryString() {
    const queryParts = [];
    // console.warn("datas", datas);
    for (const key in datas) {
      // console.warn("key", key);
      if (
        key !== "null" &&
        datas.hasOwnProperty(key) &&
        datas[key] !== null &&
        datas[key] !== undefined &&
        datas[key] !== ""
      ) {
        const value = encodeURIComponent(datas[key]);
        queryParts.push(`${key}=${value}`);
      }
    }

    return queryParts.join("&");
  }

  try {
    // console.warn("call-----------------------------------------------------------------------------------------------");
    let queryString = buildQueryString();
    console.warn("queryString-------------", queryString);

    const res = await axiosInstance.get(
      `${endpoints.videos.videos}?${queryString}`
    );
    return res;
  } catch (error) {
    return error;
  }
};
